import React, { useState, useEffect, useRef } from 'react';
import './IrisEye.css';

/**
 * IrisEye:
 *  - Renders a circular "container" that represents the 'O' in your logo.
 *  - A smaller "iris" inside it follows the mouse anywhere on the page,
 *    but is clamped inside the circle.
 */
function IrisEye() {
  // We'll store the "iris" offset from center in state
  const [pos, setPos] = useState({ x: 0, y: 0 });
  // Use a ref to measure the circle's position & size
  const circleRef = useRef(null);

  useEffect(() => {
    // Handler for mousemove on the *entire window*
    function handleMouseMove(e) {
      // If circleRef.current is not yet rendered, do nothing
      if (!circleRef.current) return;

      // Get bounding box for the circle
      const rect = circleRef.current.getBoundingClientRect();

      // The circle's center in *window* coordinates
      const centerX = rect.left + rect.width / 2 +5;
      const centerY = rect.top + rect.height / 2 +5;

      // Mouse position relative to the circle's center
      const relX = e.clientX - centerX;
      const relY = e.clientY - centerY;

      // Distance of mouse from the center
      const distance = Math.sqrt(relX * relX + relY * relY);

      // Circle's radius (minus half the iris diameter)
      // so the iris doesn't cross the circle's boundary
      const irisRadius = (rect.width / 2) - 10; 
      // 7.5 is half the iris diameter if iris is 15px

      // If outside circle, clamp to circle edge
      if (distance > irisRadius) {
        const angle = Math.atan2(relY, relX);
        setPos({
          x: irisRadius * Math.cos(angle),
          y: irisRadius * Math.sin(angle),
        });
      } else {
        // Otherwise, just use the relative positions
        setPos({ x: relX, y: relY });
      }
    }

    // Attach listener at the window level
    window.addEventListener('mousemove', handleMouseMove);

    // Cleanup
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <div className="iris-container" ref={circleRef}>
      <div 
        className="iris" 
        style={{ transform: `translate(${pos.x}px, ${pos.y}px)` }}
      />
    </div>
  );
}

export default IrisEye;
